import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const FAQ = () => {
  const { language } = useLanguage();

  const faqs = language === 'ur' ? [
    {
      question: 'عدالت بوٹ کیا ہے؟',
      answer: 'عدالت بوٹ ایک AI پر مبنی پلیٹ فارم ہے جو پاکستانی قانون کے مطابق قانونی دستاویزات تیار کرنے میں مدد کرتا ہے۔ یہ عام لوگوں کو بااختیار بناتا ہے کہ وہ بنیادی قانونی دستاویزات خود تیار کر سکیں۔'
    },
    {
      question: 'کیا یہ سروس مفت ہے؟',
      answer: 'جی ہاں، عدالت بوٹ کی بنیادی خدمات بالکل مفت ہیں۔ آپ جتنی چاہیں دستاویزات تیار کر سکتے ہیں اور محفوظ کر سکتے ہیں۔'
    },
    {
      question: 'کون سی دستاویزات تیار کی جا سکتی ہیں؟',
      answer: 'ہم مختلف قسم کی قانونی دستاویزات تیار کر سکتے ہیں جن میں شامل ہیں: درخواستیں، شکایات، نوٹس، معاہدے، وراثت کے کیس، طلاق کے کیس، جائیداد کے تنازعات، اور بہت کچھ۔'
    },
    {
      question: 'کیا تیار شدہ دستاویزات قانونی طور پر درست ہیں؟',
      answer: 'ہمارے AI ماڈل پاکستانی قوانین کی بنیاد پر دستاویزات تیار کرتے ہیں، لیکن ہم تجویز کرتے ہیں کہ اہم معاملات میں کسی وکیل سے جائزہ لیں۔ یہ ابتدائی مسودہ تیار کرنے میں مدد کرتا ہے۔'
    },
    {
      question: 'میری ذاتی معلومات کیا محفوظ ہے؟',
      answer: 'جی ہاں، ہم آپ کی رازداری کو بہت اہمیت دیتے ہیں۔ آپ کا تمام ڈیٹا انکرپٹ ہے اور محفوظ سرورز پر محفوظ ہے۔ ہم آپ کی معلومات کسی تیسرے فریق کے ساتھ شیئر نہیں کرتے۔'
    },
    {
      question: 'کیا میں دستاویز میں ترمیم کر سکتا ہوں؟',
      answer: 'جی ہاں، ایک بار دستاویز تیار ہونے کے بعد، آپ اس میں ترمیم کر سکتے ہیں اور اپنی ضروریات کے مطابق تبدیلیاں کر سکتے ہیں۔'
    },
    {
      question: 'دستاویز کیسے ڈاؤن لوڈ کریں؟',
      answer: 'دستاویز تیار ہونے کے بعد، آپ کو PDF ڈاؤن لوڈ کا بٹن نظر آئے گا۔ اس پر کلک کریں اور اپنی دستاویز محفوظ کریں۔'
    },
    {
      question: 'کیا میں آواز سے ان پٹ دے سکتا ہوں؟',
      answer: 'جی ہاں، ہمارے پاس وائس ان پٹ کی سہولت ہے۔ آپ مائیکروفون آئیکن پر کلک کرکے اردو یا انگریزی میں بول سکتے ہیں۔'
    },
    {
      question: 'دستاویز تیار ہونے میں کتنا وقت لگتا ہے؟',
      answer: 'عام طور پر، ایک دستاویز 30 سیکنڈ سے 2 منٹ میں تیار ہو جاتی ہے، آپ کی فراہم کردہ معلومات کی پیچیدگی پر منحصر ہے۔'
    },
    {
      question: 'کیا میں اپنی محفوظ کردہ دستاویزات دیکھ سکتا ہوں؟',
      answer: 'جی ہاں، اگر آپ لاگ ان ہیں تو آپ "محفوظ دستاویزات" ٹیب میں اپنی تمام پچھلی دستاویزات دیکھ سکتے ہیں۔'
    },
    {
      question: 'کیا عدالت بوٹ موبائل پر کام کرتا ہے؟',
      answer: 'جی ہاں، عدالت بوٹ مکمل طور پر موبائل فرینڈلی ہے۔ آپ اسے اپنے موبائل فون یا ٹیبلیٹ پر استعمال کر سکتے ہیں۔'
    },
    {
      question: 'مجھے مدد کیسے ملے گی؟',
      answer: 'آپ ہمارے چیٹ بوٹ سے قانونی سوالات پوچھ سکتے ہیں یا ای میل کے ذریعے رابطہ کر سکتے ہیں۔ ہماری ٹیم آپ کی مدد کے لیے تیار ہے۔'
    }
  ] : [
    {
      question: 'What is Adalat Bot?',
      answer: 'Adalat Bot is an AI-powered platform that helps generate legal documents according to Pakistani law. It empowers ordinary people to create basic legal documents themselves.'
    },
    {
      question: 'Is this service free?',
      answer: 'Yes, the basic services of Adalat Bot are completely free. You can generate and save as many documents as you want.'
    },
    {
      question: 'What types of documents can be generated?',
      answer: 'We can generate various types of legal documents including: applications, complaints, notices, contracts, inheritance cases, divorce cases, property disputes, and much more.'
    },
    {
      question: 'Are the generated documents legally valid?',
      answer: 'Our AI models generate documents based on Pakistani laws, but we recommend having important matters reviewed by a lawyer. This helps create an initial draft.'
    },
    {
      question: 'Is my personal information secure?',
      answer: 'Yes, we take your privacy very seriously. All your data is encrypted and stored on secure servers. We do not share your information with any third parties.'
    },
    {
      question: 'Can I edit the document?',
      answer: 'Yes, once the document is generated, you can edit it and make changes according to your needs.'
    },
    {
      question: 'How do I download the document?',
      answer: 'After the document is generated, you will see a PDF download button. Click on it and save your document.'
    },
    {
      question: 'Can I give voice input?',
      answer: 'Yes, we have voice input facility. You can click on the microphone icon and speak in Urdu or English.'
    },
    {
      question: 'How long does it take to generate a document?',
      answer: 'Typically, a document is generated in 30 seconds to 2 minutes, depending on the complexity of the information you provide.'
    },
    {
      question: 'Can I view my saved documents?',
      answer: 'Yes, if you are logged in, you can view all your previous documents in the "Saved Documents" tab.'
    },
    {
      question: 'Does Adalat Bot work on mobile?',
      answer: 'Yes, Adalat Bot is completely mobile-friendly. You can use it on your mobile phone or tablet.'
    },
    {
      question: 'How can I get help?',
      answer: 'You can ask legal questions from our chatbot or contact us via email. Our team is ready to help you.'
    }
  ];

  return (
    <div className={`min-h-screen bg-adalat-gradient ${language === 'ur' ? 'font-urdu' : 'font-english'}`}>
      <div className="container mx-auto py-8 px-4">
        <div className="flex justify-between items-center mb-8">
          <Header />
          <LanguageSwitcher />
        </div>

        <main className={`max-w-4xl mx-auto ${language === 'ur' ? 'rtl' : 'ltr'}`}>
          <Card className="p-8">
            <h1 className={`${language === 'ur' ? 'text-urdu-3xl text-right' : 'text-4xl'} font-bold mb-6 text-blue-700`}>
              {language === 'ur' ? 'اکثر پوچھے جانے والے سوالات' : 'Frequently Asked Questions'}
            </h1>

            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className={`${language === 'ur' ? 'text-urdu-lg text-right' : 'text-lg'} font-semibold`}>
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Card>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default FAQ;